export const blogPosts = [
    {
      id: 1,
      slug: "ahorro-universitario-guia-completa",
      title: "Guía completa para el ahorro universitario",
      excerpt: "Descubre las mejores estrategias para empezar a construir el fondo educativo de tus hijos desde sus primeros años de vida. El interés compuesto es tu mejor aliado.",
      date: "15 Ago 2025",
      category: "Ahorro",
      author: "Ana Martínez",
      image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&q=80&w=800",
      content: `
        <p>Ahorrar para la educación universitaria de tus hijos es uno de los regalos más valiosos que puedes ofrecerles. No solo les brindas oportunidades académicas, sino que también les evitas la carga de préstamos estudiantiles masivos al inicio de su vida profesional.</p>
        
        <h3>¿Por qué empezar temprano?</h3>
        <p>El tiempo es el factor más importante en cualquier inversión. Gracias al interés compuesto, pequeñas aportaciones realizadas cuando tu hijo es un bebé pueden crecer significativamente en 18 años.</p>
        
        <ul>
            <li><strong>Menor esfuerzo mensual:</strong> Empezar antes significa que necesitas ahorrar menos cada mes para llegar a la misma meta.</li>
            <li><strong>Mayor riesgo tolerable:</strong> Con un horizonte de tiempo largo, puedes invertir en instrumentos de mayor rendimiento.</li>
            <li><strong>Hábito familiar:</strong> Involucrar a la familia desde el principio crea una cultura de ahorro.</li>
        </ul>

        <h3>Herramientas disponibles</h3>
        <p>Existen diversos instrumentos financieros diseñados para este propósito, desde fideicomisos educativos hasta fondos de inversión indexados. En Appadrino, simplificamos este proceso permitiendo que múltiples personas contribuyan a un mismo objetivo de manera transparente y segura.</p>
      `
    },
    {
      id: 2,
      slug: "como-involucrar-a-los-padrinos",
      title: "¿Cómo involucrar a los padrinos en el futuro de tu hijo?",
      excerpt: "Los padrinos y abuelos suelen querer regalar cosas significativas. Aquí te damos tips para que sus regalos se conviertan en inversión a largo plazo.",
      date: "10 Ago 2025",
      category: "Familia",
      author: "Carlos Ruiz",
      image: "https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&q=80&w=800",
      content: `
        <p>Tradicionalmente, los regalos de cumpleaños y navidad consisten en juguetes que a menudo terminan olvidados en un rincón. ¿Y si pudiéramos transformar ese cariño en algo duradero?</p>

        <h3>La conversación difícil</h3>
        <p>Pedir dinero puede sentirse incómodo, pero cuando se trata de la educación, la perspectiva cambia. Explica a tus familiares que valoras su presencia y que tu deseo es construir un futuro sólido para el niño.</p>

        <h3>Estrategias prácticas</h3>
        <ul>
            <li><strong>La regla del 50/50:</strong> Sugiere que la mitad del presupuesto del regalo sea un juguete y la otra mitad vaya al fondo educativo.</li>
            <li><strong>Actualizaciones anuales:</strong> Comparte con los "Appadrinos" cuánto ha crecido el fondo gracias a sus aportes. Esto los motiva a seguir participando.</li>
        </ul>
      `
    },
    {
      id: 3,
      slug: "finanzas-para-ninos",
      title: "Educación financiera básica para niños",
      excerpt: "Nunca es demasiado pronto para enseñar el valor del dinero. Ejercicios prácticos para niños de 3 a 10 años.",
      date: "05 Ago 2025",
      category: "Educación",
      author: "Sofía López",
      image: "https://images.unsplash.com/photo-1565514020176-db78c909e752?auto=format&fit=crop&q=80&w=800",
      content: `
        <p>Enseñar a los niños sobre el dinero no se trata solo de matemáticas, sino de valores, paciencia y toma de decisiones. Aquí hay algunas formas de empezar según la edad.</p>

        <h3>3 a 5 años: El concepto de intercambio</h3>
        <p>A esta edad, los niños pueden entender que las cosas cuestan dinero. Jugar a la "tiendita" es una excelente manera de introducir el concepto de intercambio de valor.</p>

        <h3>6 a 10 años: Ahorro con metas</h3>
        <p>Es el momento ideal para las alcancías transparentes. Ver el dinero acumularse físicamente ayuda a entender el progreso. Establece metas cortas, como comprar un juguete específico, para que experimenten la recompensa de la espera.</p>
      `
    }
  ];
